import React from "react";
import { Outlet } from "react-router-dom";
import Header from "./Header";
import style from '../style/Body.module.scss'

function Body({ sidebarOpen, setSidebarOpen,setOpen,open,noticeData,closeConnection }) {
  return (
      <div
        style={{
          background: "#fff",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
        className={style.container}
      >
        <Header sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} setOpen={setOpen} open={open} noticeData={noticeData} closeConnection={closeConnection}/>
        <Outlet />
      </div>
  );
}

export default Body;
